import React, { useMemo } from 'react';

import { JobBasedSourceNode } from '@/hooks/discovery/useJobBasedExposureQuery';

interface LastCheckedTimeProps {
  sources: JobBasedSourceNode[];
  className?: string;
}

export const toHumanReadable = (date: Date): string => {
  const now = new Date(Date.now());
  const diff = now.getTime() - date.getTime();
  const days = Math.floor(diff / (24 * 60 * 60 * 1000));

  let dayString = '';

  switch (days) {
    case 0:
      if (now.getDate() === date.getDate()) {
        dayString = 'today';
      } else {
        dayString = 'yesterday';
      }
      break;
    case 1:
      if (now.getDate() - 1 === date.getDate()) {
        dayString = 'yesterday';
      } else {
        dayString = `${days.toString()} day ago`;
      }
      break;
    default:
      dayString = `${days.toString()} ${days === 1 ? `day` : `days`} ago`;
      break;
  }

  let hours = date.getHours();
  const minutes = date.getMinutes();
  let timePeriod = 'am';

  if (hours > 12) {
    timePeriod = 'pm';
    hours -= 12;
  } else if (hours === 12) {
    timePeriod = 'pm';
  } else if (hours === 0) {
    hours = 12; // midnight
  }

  if (minutes < 10) {
    return `${dayString} at ${hours}:0${minutes} ${timePeriod}`;
  }
  return `${dayString} at ${hours}:${minutes} ${timePeriod}`;
};

const getLastCheckSubTitle = (sources: JobBasedSourceNode[]): string => {
  const snapshottedSources = (sources || [])
    .filter((s) => 'state' in s && s.state !== null)
    .map((s) => new Date(s.snapshottedAt ?? '').getTime());

  const lastCheck = Math.max(...snapshottedSources);

  const date = new Date(lastCheck);
  const humanReadable = toHumanReadable(date);
  return `Last check completed ${humanReadable}`;
};

const LastCheckedTime: React.FC<LastCheckedTimeProps> = ({ sources }) => {
  const lastCheckSubtitle = useMemo(() => getLastCheckSubTitle(sources), [sources]);

  return (
    <div className="px-8 py-4">
      <span className="text-dbt-gray italic">{lastCheckSubtitle}</span>
    </div>
  );
};

export default LastCheckedTime;
